export const LOGIN_TABS = [
  { id: '01', name: 'Вход по телефону' },
  { id: '02', name: 'Вход по e-mail' }
]
